module.exports = __webpack_public_path__ + "static/media/arrowRight.5c1ad9ed.svg";